import Icon from '../components/Icon'

Icon.register({
  'apple-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M350.9 129c26 4.7 47.3 18.7 63.9 42 14.7 20.7 24.6 46.7 30 78 4.7 28.7 4.3 57.3-1 86-8 47.3-24 87-47.9 119-28.6 38.7-64.6 58-107.9 58-10.7 0-22.3-3.3-35-10-8.7-5.3-18.3-8-29-8s-20.3 2.7-29 8c-12.7 6.7-24.3 10-35 10-43.3 0-79.2-19.3-107.9-58-24-32-40-71.7-47.9-119-5.3-28.7-5.7-57.3-1-86 5.3-31.3 15.3-57.3 30-78 16.7-23.3 38-37.3 63.9-42 16-2.7 38-0.3 65.9 7 24 6.7 44.3 14.7 60.9 24 16.6-9.3 37-17.3 60.9-24 28-7.3 50-9.7 65.9-7zM295.9 88c-9.3 8.7-21.7 15-37 19-10.7 3.3-22.3 5-35 5l-15-1c-1.3-9.3-1.3-20 0-32 2.7-24 10.3-42.3 23-55 9.3-8.7 21.6-15 37-19 10.7-3.3 22.3-5 35-5l15 1 1 15c0 12.7-1.7 24.3-5 35-4 15.3-10.3 27.7-19 37z'
      }
    ]
  }
})
